"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CatalystClient = void 0;
const dcl_catalyst_commons_1 = require("dcl-catalyst-commons");
const Helper_1 = require("./utils/Helper");
const ContentClient_1 = require("./ContentClient");
const LambdasClient_1 = require("./LambdasClient");
const CatalystClientBuilder_1 = require("./utils/CatalystClientBuilder");
class CatalystClient {
    constructor(catalystUrl, origin, // The name or a description of the app that is using the client
    fetcher) {
        this.catalystUrl = Helper_1.sanitizeUrl(catalystUrl);
        fetcher =
            fetcher !== null && fetcher !== void 0 ? fetcher : new dcl_catalyst_commons_1.Fetcher({
                headers: Helper_1.getHeadersWithUserAgent('catalyst-client')
            });
        this.contentClient = new ContentClient_1.ContentClient(this.catalystUrl + '/content', origin, fetcher);
        this.lambdasClient = new LambdasClient_1.LambdasClient(this.catalystUrl + '/lambdas', fetcher);
    }
    deployEntity(deployData, fix = false, options) {
        return this.contentClient.deployEntity(deployData, fix, options);
    }
    fetchEntitiesByPointers(type, pointers, options) {
        return this.contentClient.fetchEntitiesByPointers(type, pointers, options);
    }
    fetchEntitiesByIds(type, ids, options) {
        return this.contentClient.fetchEntitiesByIds(type, ids, options);
    }
    fetchEntityById(type, id, options) {
        return this.contentClient.fetchEntityById(type, id, options);
    }
    fetchAuditInfo(type, id, options) {
        return this.contentClient.fetchAuditInfo(type, id, options);
    }
    fetchContentStatus(options) {
        return this.contentClient.fetchContentStatus(options);
    }
    fetchAllDeployments(deploymentOptions, options) {
        return this.contentClient.fetchAllDeployments(deploymentOptions, options);
    }
    streamAllDeployments(deploymentOptions, options) {
        return this.contentClient.streamAllDeployments(deploymentOptions, options);
    }
    isContentAvailable(cids, options) {
        return this.contentClient.isContentAvailable(cids, options);
    }
    downloadContent(contentHash, options) {
        return this.contentClient.downloadContent(contentHash, options);
    }
    pipeContent(contentHash, writeTo, options) {
        return this.contentClient.pipeContent(contentHash, writeTo, options);
    }
    fetchProfiles(ethAddresses, profileOptions, options) {
        return this.lambdasClient.fetchProfiles(ethAddresses, profileOptions, options);
    }
    fetchWearables(filters, options) {
        return this.lambdasClient.fetchWearables(filters, options);
    }
    fetchOwnedWearables(ethAddress, includeDefinitions, options) {
        return this.lambdasClient.fetchOwnedWearables(ethAddress, includeDefinitions, options);
    }
    fetchCatalystsApprovedByDAO(options) {
        return this.lambdasClient.fetchCatalystsApprovedByDAO(options);
    }
    fetchLambdasStatus(options) {
        return this.lambdasClient.fetchLambdasStatus(options);
    }
    getCatalystUrl() {
        return this.catalystUrl;
    }
    getContentUrl() {
        return this.contentClient.getContentUrl();
    }
    getLambdasUrl() {
        return this.lambdasClient.getLambdasUrl();
    }
    static connectedToCatalystIn(network, origin) {
        return CatalystClientBuilder_1.clientConnectedToCatalystIn(network, origin);
    }
}
exports.CatalystClient = CatalystClient;
//# sourceMappingURL=CatalystClient.js.map